













import Vue from 'vue';
import axios from 'axios';

export default Vue.extend(
    {
        data() {
            return {
                url: "",
                title: "",
                date: ""
            }
        },
        methods: {
            fetchAPOD: function () {
                //let apiKey = 'DEMO_KEY'; //replace with real apikey. demo key is for limited use only
                let apiKey = '7mUh8iioKZFlbIvludFrzdeUauQeReg35rNZUqyE' //nasa.gov api key for dutch@adachis.info
                let url = 'https://api.nasa.gov/planetary/apod?api_key=' + apiKey;
                axios.get(url)
                    .then((res) => {
                        this.url = res.data.url;
                        this.title = res.data.title;
                        this.date = res.data.date;
                    })
            }

        },
        computed: {
            urlisImage: function (): boolean {
                return (this.url.includes('.jpg'))//APOD api sometimes return youtube Video. Need to address this
            }
        },

        created: function () {
            this.fetchAPOD();
        }

    }
)
